import { render, staticRenderFns } from "./hospitalization-form.vue?vue&type=template&id=61edf1cf&"
import script from "./hospitalization-form.vue?vue&type=script&lang=js&"
export * from "./hospitalization-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports